import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Subtitle"] */ "/app/src/app/(home)/components/Subtitle.tsx");
